import { Shadow, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Text as NBText } from 'native-base';
import React from 'react';

interface PayloadData {
  name: string;
  color: string;
  payload: any;
}

interface Props {
  active?: boolean;
  label?: string;
  tags: Record<string, string>;
  namesMap: Map<string, string>;
  payload?: PayloadData[] | any[];
}

export const LineChartTooltip = (props: Props) => {
  const { active, payload, label, namesMap, tags } = props;
  if (!active || !label || !payload || !payload.length) {
    return null;
  }

  return (
    <Shadow testId="shadow" level={1}>
      <VStack
        background={Color['neutral.white']}
        p={Spacing['inset.nano']}
        space={Spacing['inset.quarck']}
        w="165px">
        <Text>{String(namesMap.get(label))}</Text>
        {payload.map((item: PayloadData) => (
          <HStack alignItems="center" key={item.name} space={Spacing['inline.nano']}>
            <Box w="8px" h="8px" background={item.color} borderRadius="full" />
            <NBText variant="regular" fontSize={Typography['fontsize.md']}>
              {`${tags[item.name]}: `}
              <NBText
                variant="semibold"
                fontSize={Typography['fontsize.md']}
                {...((item.payload[`${item.name}P`] as string).startsWith('-') && {
                  color: Color['feedback.error.default'],
                })}>
                {item.payload[`${item.name}P`]}
              </NBText>
            </NBText>
          </HStack>
        ))}
      </VStack>
    </Shadow>
  );
};
